import { closestCenter, DndContext } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { classNames } from "primereact/utils";
import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import PrimeDialog from "../../../components/dialog/PrimeDialog";
import { FormInput } from "../../../components/FormInput";
import FormNumberInput from "../../../components/FormNumberInput";
import { FormTextarea } from "../../../components/FormTextarea";
import PrimePanel from "../../../components/PrimePanel";
import { useEditableFlag } from "../../../hooks/useEditableFlag";
import { checkLoading, SystemLoading } from "../../../store/loadingStore";
import { handleSuccessMessage, MessageContext } from "../../../store/messageStore";
import { getSubItemsByItemNo } from "../../../utility/service/api-service";
import {
  copyImportanceEvaluationTemp,
  createEvaluateTemplate,
  deleteEvaluationTemplate,
  F101031002Before,
  F101031003Before,
  queryEvaluateItems,
  queryEvaluateSetting,
  queryEvaluationTemplate,
  queryEvaluationTemplateDetail,
  updateEvaluateTemplate,
} from "../../../utility/service/importanceIdentification-service";
import { checkDpSuccess } from "../../../utility/service/tool-service";
import { addFormValidator } from "../../../utility/validate/formValidator";
import { CusEvalItemComponent } from "./CusEvalItemComponent";
import CusEvalSettingComponent from "./CusEvalSettingComponent";
import { EvaluationCriteriaSetting } from "./EvaluationCriteriaSetting";

// 評估範本設定
const EvaluationTempSetting = ({ activeIndex = 2 }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { itemObj, setItemObj, setAction, action } = useOutletContext();
  const [existTemplateListOpt, setExistTemplateListOpt] = useState([]);
  const [enableFlagList, setEnableFlagList] = useState([]);
  const [evaluateSettingList, setEvaluateSettingList] = useState([]);
  const [evaluateItemList, setEvaluateItemList] = useState([]);

  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [criterialDialog, setCriterialDialog] = useState(false);
  const [copyDialog, setCopyDialog] = useState(false);
  const [, loading] = useContext(SystemLoading);
  const isEditable = useEditableFlag("F10103"); // control edit by F10103

  const [selectTemplateSeq, setSelectTemplateSeq] = useState("");
  const [delTemplatePopup, setDelTemplatePopup] = useState(false);
  //表單驗證
  const [formRule, setFormRule] = useState([]);

  const {
    register,
    handleSubmit,
    resetField,
    reset,
    watch,
    getValues,
    setValue,
    clearErrors,
    control,
    trigger,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      evalTempRadio: "addTemp",
      copyEvaluationTemplateId: "",
    },
    //錯誤驗證時機
    mode: "all",
  });

  const watchEvalTempRadio = watch("evalTempRadio");

  const {
    fields: evalSettingFields,
    append: addSettingForm,
    remove: delSettingForm,
    move: moveSettingForm,
  } = useFieldArray({
    control,
    name: "evaluateSettingList",
  });

  const {
    fields: evalDetailFields,
    append: addDetailForm,
    remove: delDetailForm,
    move: moveDetailForm,
  } = useFieldArray({
    control,
    name: "evaluationDetailsList",
  });

  const handleResetForm = (index) => {
    delSettingForm(index);
    addSettingForm({ evaluationId: "" });
    clearErrors();
  };

  const handleResetDetailForm = (index) => {
    delDetailForm(index);
    addDetailForm({ displayName: "" });
    clearErrors();
    reset((pre) => {
      return {
        ...pre,
      };
    });
  };

  const handleDelForm = (index, length) => {
    if (length > 1) {
      delSettingForm(index);
    } else {
      delSettingForm(index);
      addSettingForm({ evaluationId: "" });
    }
  };

  const handleDelDetailForm = (index, length) => {
    if (length > 1) {
      delDetailForm(index);
    } else {
      delDetailForm(index);
      addDetailForm({ displayName: "" });
    }
  };

  const checkCompanySeq = () => {
    if (!itemObj?.companySeq) {
      navigate("/management/carbonFootprint/detail", { state: { activeIndex } });
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (checkCompanySeq()) return;
  }, [itemObj]);

  useEffect(() => {
    if (checkCompanySeq()) return;
    getSubItemsByItemNo("ENABLE_STATUS", 18).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setEnableFlagList(newArray);
      }
    });
    axios_queryEvaluateSetting();
    axios_queryEvaluateItems();
  }, []);

  useEffect(() => {
    if (checkCompanySeq()) return;
    if ((watchEvalTempRadio === "existTemp" || watchEvalTempRadio === "copyTemp") && JSON.stringify(itemObj) !== "{}") {
      axios_queryEvaluationTempalte();
      handleUpdate();
    } else {
      handleCreate();
    }
    initFormData();
    setSelectTemplateSeq("");
  }, [watchEvalTempRadio]);

  const handleCreate = async () => {
    const res = await F101031002Before();
    if (checkDpSuccess(res)) {
      setFormRule(processConstraints(res?.data?.RespBody?.constraints));
    }
  };

  const handleUpdate = async () => {
    const res = await F101031003Before();
    if (checkDpSuccess(res)) {
      setFormRule(processConstraints(res?.data?.RespBody?.constraints));
    }
  };

  const processConstraints = (constraints) => {
    return constraints.map((item) => {
      if (item?.subObject?.value) {
        return { [item?.field]: processConstraints(item?.subObject.value) };
      } else {
        return addFormValidator(item?.field, constraints);
      }
    });
  };

  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule]
  );

  // 初始化表單
  const initFormData = () => {
    setValue("enableFlag", "");
    setValue("evaluationMethod", "");
    setValue("evaluationTemplateName", "");
    setValue("score", "");
    setValue("evaluationDetailsList", [{ displayName: "" }]);
    setValue("evaluateSettingList", [{ evaluationId: "" }]);
    setValue("evaluationTemplateId", "");
    clearErrors();
  };

  // 設定範本資料
  const setTempFormData = (data) => {
    setValue("enableFlag", data?.enableFlag);
    setValue("evaluationMethod", data?.evaluationMethod);
    setValue("evaluationTemplateName", data?.evaluationTemplateName);
    setValue("score", data?.score);
    let evalSetting = [];
    evalSetting = data?.evaluateSettingList?.map((item, index) => {
      return {
        sort: index + 1,
        evaluationId: item?.evaluationId,
      };
    });
    setValue("evaluateSettingList", evalSetting);
    let evalItem = data?.evaluationDetailsList?.map((item) => {
      return {
        classNo: item.classNo,
        displayName: item.displayName,
        typeName: item.typeName,
        typeSeq: item.typeSeq,
        sort: item.sort,
      };
    });
    setValue("evaluationDetailsList", evalItem);
  };

  // 評估標準清單查詢
  const axios_queryEvaluateSetting = () => {
    queryEvaluateSetting({ companySeq: itemObj?.companySeq, useCase: "U" }).then((res) => {
      if (checkDpSuccess(res)) {
        setEvaluateSettingList(res?.data?.RespBody?.evaluations?.options);
      }
    });
  };

  // 評估標準項目查詢
  const axios_queryEvaluateItems = () => {
    queryEvaluateItems().then((res) => {
      if (checkDpSuccess(res)) {
        setEvaluateItemList(res?.data?.RespBody?.sourceType);
      }
    });
  };

  // 重大性評估範本清單查詢
  const axios_queryEvaluationTempalte = () => {
    queryEvaluationTemplate({
      companySeq: itemObj?.companySeq,
      useCase: watchEvalTempRadio !== "copyTemp" ? "E" : "U",
    }).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res?.data?.RespBody?.evaluationTemplates?.options;
        setExistTemplateListOpt(data);
      }
    });
  };

  const checkKeyDown = (e) => {
    // if (e.key === 'Enter') e.preventDefault();
    if (e.keyCode === 13) {
      e.stopPropagation();
    }
  };

  // 避免觸發 按enter 後 就觸發 onSubmit 事件冒泡 給input 使用 <FormInput enterClick事件 ; 一般input onKeyDown事件
  const inputCheckKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  // 評估標準詳情查詢
  const axios_queryEvaluationTemplateDetail = (tempId) => {
    checkLoading(loading);
    queryEvaluationTemplateDetail({ evaluationTemplateId: tempId })
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res?.data?.RespBody;
          setTempFormData(data);
          clearErrors();
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  // 刪除評估範本
  const delTemplate = () => {
    checkLoading(loading);
    deleteEvaluationTemplate({ evaluationTemplateId: selectTemplateSeq })
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.delete") + " " + t("message.success"));
          setValue("evaluationTemplateId", "");
          initFormData(); // 刪除成功後清除畫面
          axios_queryEvaluationTempalte();
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
        setDelTemplatePopup(false);
        setSelectTemplateSeq("");
      });
  };

  const confirmCopyTemplate = () => {
    checkLoading(loading);
    copyImportanceEvaluationTemp({ evaluationTemplateId: watch("copyEvaluationTemplateId") })
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res?.data?.RespBody;
          handleSuccessMessage(dispatch, t("button.copy") + " " + t("message.success"));
          setCopyDialog(false);
          setValue("evalTempRadio", "existTemp");
          setValue("evaluationTemplateId", data?.evaluationTemplateId);
          axios_queryEvaluationTemplateDetail(data?.evaluationTemplateId);
          setSelectTemplateSeq(data?.evaluationTemplateId);
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  // 拖曳評估標準
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = evalSettingFields.findIndex((item) => item.id === active.id);
      const newIndex = evalSettingFields.findIndex((item) => item.id === over.id);
      moveSettingForm(oldIndex, newIndex);
      console.log(evalSettingFields);
    }
  };

  // 拖曳評估項目
  const handleDragEndDetail = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = evalDetailFields.findIndex((item) => item.id === active.id);
      const newIndex = evalDetailFields.findIndex((item) => item.id === over.id);
      moveDetailForm(oldIndex, newIndex);
    }
  };

  const onSubmit = (data) => {
    checkLoading(loading);
    let reqBody = {
      evaluationTemplateName: data.evaluationTemplateName,
      evaluationMethod: data.evaluationMethod,
      enableFlag: data.enableFlag,
      score: data.score,
    };
    let evalSetting = [];
    if (data.evaluateSettingList?.length > 0) {
      evalSetting = data.evaluateSettingList?.map((item, index) => {
        return {
          evaluationId: item.evaluationId,
          sort: index + 1,
        };
      });
      reqBody.evaluateSettingList = evalSetting;
    }

    let evalItem = [];
    if (data.evaluationDetailsList?.length > 0) {
      evalItem = data.evaluationDetailsList?.map((item, index) => {
        return {
          typeSeq: item.typeSeq,
          classNo: item.classNo,
          displayName: item.displayName,
          sort: (index + 1).toString(),
        };
      });
      reqBody.evaluationDetailsList = evalItem;
    }

    if (watchEvalTempRadio === "existTemp") {
      //update
      reqBody["evaluationTemplateId"] = data.evaluationTemplateId;

      updateEvaluateTemplate(reqBody)
        .then((res) => {
          if (checkDpSuccess(res)) {
            handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
            axios_queryEvaluationTempalte(); //更新成功後刷新範本清單
          }
        })
        .finally((fin) => {
          checkLoading(loading, false);
        });
    } else {
      createEvaluateTemplate(reqBody)
        .then((res) => {
          if (checkDpSuccess(res)) {
            if (watchEvalTempRadio === "addTemp") {
              handleSuccessMessage(dispatch, t("button.create") + " " + t("message.success"));
              initFormData(); //新增成功後清除畫面
            } else {
              setValue("evaluationTemplateId", res.data.RespBody.evaluationTemplateId);
              handleSuccessMessage(dispatch, t("button.copy") + " " + t("message.success"));
              axios_queryEvaluationTempalte(); //更新成功後刷新範本清單
            }
          }
        })
        .finally((fin) => {
          checkLoading(loading, false);
        });
    }
  };

  return (
    <>
      <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
          <Button
            rounded
            text
            onClick={() => {
              navigate("/management/carbonFootprint/detail", { state: { activeIndex: activeIndex } });
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t("button.return_to_list")}
          </Button>
        </div>
        {/* <div className="align-items-end">
            { action==='create'?t('button.create'):t('button.detail')}
        </div> */}
      </div>
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
        <div className="col-12 grid">
          <h3>{t("evaluation_template_settings")}</h3>
          <div className="col-12">
            <label className="control-label">{t("evaluation_template")}</label>
          </div>

          <Controller
            name="evalTempRadio"
            control={control}
            rules={{ required: "Value is required." }}
            render={({ field }) => {
              return (
                <div className="col-12 flex flex-wrap gap-3 align-items-center">
                  <div className="flex align-items-center gap-2">
                    <RadioButton
                      inputId="addTemp"
                      {...field}
                      inputRef={field.ref}
                      value="addTemp"
                      checked={field.value === "addTemp"}
                      onChange={(e) => {
                        field.onChange(e.value);
                      }}
                    />
                    <label htmlFor="addTemp" className="mx-2">
                      {t("add_template")}
                    </label>
                  </div>
                  <div className="flex align-items-center gap-2">
                    <RadioButton
                      inputId="copyTemp"
                      {...field}
                      inputRef={field.ref}
                      value="copyTemp"
                      checked={field.value === "copyTemp"}
                      onChange={(e) => {
                        field.onChange(e.value);
                      }}
                    />
                    <label htmlFor="copyTemp" className="mx-2">
                      {t("copyTemplate")}
                    </label>
                  </div>
                  <div className="flex align-items-center gap-2">
                    <RadioButton
                      inputId="existTemp"
                      {...field}
                      inputRef={field.ref}
                      value="existTemp"
                      checked={field.value === "existTemp"}
                    />
                    <label htmlFor="existTemp" className="mx-2">
                      {t("existing_templates")}
                    </label>
                  </div>
                </div>
              );
            }}
          />

          {(watchEvalTempRadio === "existTemp" || watchEvalTempRadio === "copyTemp") && (
            <div className="col-12">
              <Controller
                name="evaluationTemplateId"
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    appendTo={"self"}
                    optionLabel="label"
                    optionValue="value"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="evaluationTemplateId"
                    control={control}
                    options={existTemplateListOpt}
                    className={`w-full lg:w-6` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                      setSelectTemplateSeq(event.value);
                      axios_queryEvaluationTemplateDetail(event.value);
                    }}
                  />
                )}
              />
            </div>
          )}

          <div className="col-12 lg:col-6">
            <FormInput
              register={register}
              errors={errors}
              id="evaluationTemplateName"
              name="evaluationTemplateName"
              type="text"
              labelClass="required"
              rules={setValidForm("evaluationTemplateName")}
              labelText={t("evaluationTemplateName")}
            />
          </div>

          <div className="col-12 lg:col-3">
            <FormNumberInput
              register={register}
              errors={errors}
              id="score"
              name="score"
              labelClass="required"
              rules={setValidForm("score")}
              labelText={`${t("thresholdScore")}(>)`}
              value={watch("score")}
              onChange={(newValue) => setValue("score", newValue)}
            />
          </div>

          <div className="col-12 lg:col-3">
            <label htmlFor="enableFlag" className="form-label required">
              {t("enable")}{" "}
            </label>
            <Controller
              name="enableFlag"
              control={control}
              rules={setValidForm("enableFlag")}
              // rules={setValidForm("enableFlag")}
              render={({ field, fieldState }) => (
                <Dropdown
                  optionLabel="subitemName"
                  optionValue="subitemNo"
                  appendTo={"self"}
                  value={field.value}
                  virtualScrollerOptions={{ itemSize: 40 }}
                  defaultValue={""}
                  placeholder={t("plz_chs")}
                  name="enableFlag"
                  control={control}
                  options={enableFlagList}
                  className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                  onChange={(event) => {
                    field.onChange(event.value);
                  }}
                />
              )}
            />
          </div>

          <div className="col-12">
            <FormTextarea
              register={register}
              errors={errors}
              id="evaluationMethod"
              name="evaluationMethod"
              type="text"
              labelText={t("evaluation_method_desp")}
              labelClass="required"
              areaClass="w-full"
              rules={setValidForm("evaluationMethod")}
            />
          </div>

          <div className="col-12">
            <PrimePanel
              toggleable
              className="evaluation-temp-setting-panel"
              style={{ "--col": "1" }}
              header={
                <>
                  <span>{t("evaluation_criteria")} </span>
                  <Button
                    type="button"
                    size="small"
                    text
                    icon="pi pi-cog"
                    severity="secondary"
                    onClick={() => {
                      setCriterialDialog(true);
                    }}
                    label={t("evaluation_criteria_settings")}
                  />
                </>
              }
            >
              <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                  <SortableContext items={evalSettingFields.map((f) => f.id)} strategy={verticalListSortingStrategy}>
                    {evalSettingFields?.map((field, index) => (
                      <CusEvalSettingComponent
                        key={field.id}
                        evaluateSettingList={evaluateSettingList}
                        register={register}
                        errors={errors}
                        fieldName={`evaluateSettingList.${index}`}
                        inputCheckKeyDown={inputCheckKeyDown}
                        fields={evalSettingFields}
                        handleResetForm={handleResetForm}
                        handleDelForm={() => {
                          handleDelForm(index, evalSettingFields?.length);
                        }}
                        index={index}
                        action={action}
                        control={control}
                        isReadOnly={false}
                        rowData={field}
                      />
                    ))}
                  </SortableContext>
                </DndContext>
                <div className="form-group pt-3">
                  <button
                    type="button"
                    className="icon-btn"
                    onClick={() => {
                      addSettingForm({ evaluationId: "" });
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                </div>
              </div>
            </PrimePanel>
          </div>

          <div className="col-12">
            <PrimePanel
              toggleable
              className="evaluation-temp-setting-panel"
              style={{ "--col": "2" }}
              header={t("evaluation_items")}
            >
              <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEndDetail}>
                  <SortableContext items={evalDetailFields.map((f) => f.id)} strategy={verticalListSortingStrategy}>
                    {evalDetailFields?.map((field, index) => {
                      return (
                        <CusEvalItemComponent
                          key={field.id}
                          evaluateItemList={evaluateItemList ?? []}
                          register={register}
                          errors={errors}
                          trigger={trigger}
                          fieldName={`evaluationDetailsList.${index}`}
                          inputCheckKeyDown={inputCheckKeyDown}
                          fields={evalDetailFields}
                          handleResetForm={handleResetDetailForm}
                          handleDelForm={() => {
                            handleDelDetailForm(index, evalDetailFields?.length);
                          }}
                          index={index}
                          action={action}
                          control={control}
                          isReadOnly={false}
                          setValue={setValue}
                          getValues={getValues}
                          rowData={field}
                        />
                      );
                    })}
                  </SortableContext>
                </DndContext>

                <div className="form-group pt-3">
                  <button
                    type="button"
                    className="icon-btn"
                    onClick={() => {
                      addDetailForm({ displayName: "" });
                      clearErrors([]);
                    }}
                  >
                    <i className="pi pi-plus"></i>
                  </button>
                </div>
              </div>
            </PrimePanel>
          </div>
        </div>

        <div className="col-12 gap-2 flex-all-center">
          <Button
            disabled={!isValid || !isEditable}
            type="submit"
            label={
              watchEvalTempRadio === "addTemp"
                ? t("button.add")
                : watchEvalTempRadio === "existTemp"
                ? t("button.update")
                : t("button.copy")
            }
            size="small"
          />
          {getValues("evalTempRadio") === "existTemp" && (
            <Button
              type="button"
              disabled={selectTemplateSeq === ""}
              size="small"
              severity="danger"
              label={t("button.delete")}
              onClick={(e) => {
                setDelTemplatePopup(true);
              }}
            />
          )}
          <Button
            type="button"
            outlined
            size="small"
            label={t("button.cancel")}
            onClick={(e) => {
              e.preventDefault();
              clearErrors();
              navigate("/management/carbonFootprint/detail", { state: { activeIndex: activeIndex } });
            }}
          />
        </div>
      </form>

      <PrimeDialog
        visible={criterialDialog}
        size="lg"
        isShowCancelBtn={false}
        isShowConfBtn={false}
        onClose={() => {
          setCriterialDialog(false);
          axios_queryEvaluateSetting();
        }}
        title={t("evaluation_criteria_settings")}
        bodyTemplate={<EvaluationCriteriaSetting setCloseDialog={setCriterialDialog} />}
      />

      {/* copy temp Dialog */}
      {/* <PrimeDialog
        visible={copyDialog}
        size="md"
        disabledConfirm={watch("copyEvaluationTemplateId") === ""}
        onClose={() => {
          setCopyDialog(false);
          setValue("copyEvaluationTemplateId", "");
        }}
        onConfirm={() => {
          confirmCopyTemplate();
        }}
        title={t("copyTemplate")}
        bodyTemplate={<CusCopyTemplate itemObj={itemObj} control={control} />}
      /> */}

      <PrimeDialog
        visible={delTemplatePopup}
        size="sm"
        isShowConfBtn={false}
        isShowDelBtn={true}
        onClose={() => {
          setDelTemplatePopup(false);
        }}
        onDelete={() => {
          delTemplate();
        }}
        title={`${t("evaluation_template")}${t("button.delete")}`}
        bodyTemplate={t("evaluationTemplateDelContent")}
      />
    </>
  );
};

export default EvaluationTempSetting;
